<template>
  <div :class="keyboardClass"></div>
</template>

<script>
import Keyboard from "simple-keyboard";
import inputMask from 'simple-keyboard-input-mask';

import "simple-keyboard/build/css/index.css";

export default {
    name: "SimpleKeyboard",
    props: {
        keyboardClass: {
            type: String,
            default: "simple-keyboard",
        },
        input: {
          type: String
        },
    },
    data: () => ({
        keyboard: null,
        text: false
    }),
    mounted () {
        this.keyboard = new Keyboard({
            onChange: this.onChange,
            onKeyPress: this.onKeyPress,
            disableCaretPositioning: true,
            layout: {
                default: ["1 2 3", "4 5 6", "7 8 9", "{//} 0 {//}", "{bksp}"],
                shift: ["! / #", "$ % ^", "& * (", "{shift} ) +", "{bksp}"]
            },
            theme: "hg-theme-default hg-layout-numeric numeric-theme",
            display: {
              "{bksp}": "Apagar",
              "{//}": " "
            }
        })
    },
    methods: {
        onChange(input) {
         
          this.$emit("onChange", input);
        },
        onKeyPress(button) {
            this.$emit("onKeyPress", button);

            if (button === "{shift}" || button === "{lock}") this.handleShift();

        },
        handleShift() {
            let currentLayout = this.keyboard.options.layoutName;
            let shiftToggle = currentLayout === "default" ? "shift" : "default";

            this.keyboard.setOptions({
                layoutName: shiftToggle,
                inputMask
            });
        }
    },
    watch: {
      input(input) {
        this.keyboard.setInput(input);
      }
    }
}
</script>

<style scoped>
.simple-keyboard {
  /* position: absolute;
  bottom: 5%;
  z-index: 999;
  margin: 0 auto; */
}

input {
  width: 100%;
  height: 100px;
  padding: 20px;
  font-size: 20px;
  border: none;
  box-sizing: border-box;
}

/*
  Theme: numeric
*/
.numeric-theme {
  max-width: 70%;
  margin: 0 auto;
}

.numeric-theme + .simple-keyboard-preview {
  max-width: 320px;
}

.simple-keyboard.hg-theme-default.numeric-theme
  .hg-button.hg-standardBtn.hg-button-at {
  /* max-width: none; */
  
  /* bottom: 20%; */
  z-index: 999;
}



</style>